import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles(() => {
  return createStyles({
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: colorsPalette.blueDark,
      flexGrow: 1,
    },
  });
});
export default useStyles;
